<template>
  <SidebarLayout>
    <!-- Sidebar -->
    <template v-slot:sidebar="{ sidebar }">
      <div class="d-flex flex-column my-4">
        <v-btn v-for="item in menu" :key="item.tab" text :block="sidebar" @click="tab = item.tab" :icon="!sidebar" color="white" :title="item.title" :class="['mb-4', sidebar ? 'left-align-btn' : 'mx-auto']">
          <v-icon :left="sidebar">{{ item.icon }}</v-icon> <span v-if="sidebar">{{ item.title }}</span>
        </v-btn>
      </div>
    </template>
    <!-- Main -->
    <template v-slot:main>
      <LessonCreator v-if="tab === 0" />
      <LessonPreview v-if="tab === 1" />
      <LessonEditor v-if="tab === 2" />
      <LessonExperiment v-if="tab === 3" />
      <LessonResults v-if="tab === 4" />
      <LessonSettings v-if="tab === 5" />
    </template>
  </SidebarLayout>
</template>

<script>
import { doc, getDoc } from 'firebase/firestore'
import { db } from '@/firebase/init'

import SidebarLayout from '@/layouts/Sidebar.vue';
import LessonCreator from '@/components/lessons/LessonCreator.vue';
import LessonPreview from '@/components/lessons/LessonPreview.vue';
import LessonEditor from '@/components/lessons/LessonEditor.vue';
import LessonExperiment from '@/components/lessons/LessonExperiment.vue';
import LessonResults from '@/components/lessons/LessonResults.vue';
import LessonSettings from '@/components/lessons/LessonSettings.vue';


export default {

  name: 'RealmLesson',
  
  components: {
    SidebarLayout,
    LessonCreator,
    LessonPreview,
    LessonEditor,
    LessonExperiment,
    LessonResults,
    LessonSettings,
  },

  data() {
    return {
      tab: 0,
      lesson: null,
      loading: false,
      sparkyCollapsed: false,
      menu: [
        { title: 'Creator', icon: 'mdi-creation', tab: 0 },
        { title: 'Preview', icon: 'mdi-controller', tab: 1 },
        { title: 'Editor', icon: 'mdi-file-document-edit-outline', tab: 2 },
        { title: 'Experiment', icon: 'mdi-test-tube', tab: 3 },
        { title: 'Results', icon: 'mdi-chart-bar', tab: 4 },
        { title: 'Settings', icon: 'mdi-cog-outline', tab: 5 },
      ],
    }
  },

  methods: {

    intitialize() {
      // Load the lesson from Firestore or Create a new one
      this.loading = true;
      let lessonId = this.$route.params.id;
      if (lessonId) {
        this.loadLesson(lessonId);
      }
    },

    loadLesson(lessonId) {
      // Load the lesson from Firestore
      const lessonRef = doc(db, 'lessons', lessonId);
      getDoc(lessonRef).then((doc) => {
        if (doc.exists()) {
          this.lesson = { id: doc.id, ...doc.data() };
        } else {
          console.error("No such lesson document!");
          this.lesson = null;
        }
        this.loading = false;
      }).catch(error => {
        console.error("Error getting document:", error);
        this.loading = false;
      });
    },
  },

  mounted() {
    this.intitialize()
  }
}
</script>
